const ordersQueryUrl = (endpoint, query = {}) => {
  const { status, regionID, pharmacyID, page, limit, collection, delivery, reverse } = query
  const statusQuery = status ? `&status=${status}` : '';
  const reverseQuery = reverse ? '&reverse=true' : '';
  const collectionQuery = collection ? `&collection=${collection}` : ''
  const deliveryQuery = delivery ? `&delivery=${delivery}` : ''
  const regionQuery = regionID ? `&region=${regionID}` : ''
  const pharmacyQuery = pharmacyID ? `&pharmacy_id=${pharmacyID}` : ''
  const pageQuery = `&page=${page ? page : 0}`
  const limitQuery = `&limit=${limit ? limit : 10}`
  return `/${endpoint}?${statusQuery}${reverseQuery}${collectionQuery}${deliveryQuery}${regionQuery}${pharmacyQuery}${pageQuery}${limitQuery}`
}

export default ordersQueryUrl
